import { render, staticRenderFns } from "./StaffCompanyInstruction.vue?vue&type=template&id=4996030b&scoped=true&"
import script from "./StaffCompanyInstruction.vue?vue&type=script&lang=js&"
export * from "./StaffCompanyInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4996030b",
  null
  
)

export default component.exports